




















































































import { userState } from '@/store';
import { Component, Ref, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import FormLabel from '@/components/FormLabel.vue';

@Component({ components: { FormLabel } })
export default class BillingAddressModal extends Vue {
  public models = {
    title: '',
    addressStreet: '',
    addressStreetNumber: '',
    addressZipCode: '',
    addressCity: '',
    addressCountry: '',
  };

  @Ref('billingAddressModal')
  public modal: any;

  public countries = _.sortBy(
    [
      { value: 'AD', label: `${this.$t('countries.AD')}` },
      { value: 'AT', label: `${this.$t('countries.AT')}` },
      { value: 'BA', label: `${this.$t('countries.BA')}` },
      { value: 'BE', label: `${this.$t('countries.BE')}` },
      { value: 'BG', label: `${this.$t('countries.BG')}` },
      { value: 'BY', label: `${this.$t('countries.BY')}` },
      { value: 'CH', label: `${this.$t('countries.CH')}` },
      { value: 'CY', label: `${this.$t('countries.CY')}` },
      { value: 'CZ', label: `${this.$t('countries.CZ')}` },
      { value: 'DE', label: `${this.$t('countries.DE')}` },
      { value: 'DK', label: `${this.$t('countries.DK')}` },
      { value: 'EE', label: `${this.$t('countries.EE')}` },
      { value: 'ES', label: `${this.$t('countries.ES')}` },
      { value: 'FI', label: `${this.$t('countries.FI')}` },
      { value: 'FR', label: `${this.$t('countries.FR')}` },
      { value: 'GB', label: `${this.$t('countries.GB')}` },
      { value: 'GR', label: `${this.$t('countries.GR')}` },
      { value: 'HR', label: `${this.$t('countries.HR')}` },
      { value: 'HU', label: `${this.$t('countries.HU')}` },
      { value: 'IE', label: `${this.$t('countries.IE')}` },
      { value: 'IS', label: `${this.$t('countries.IS')}` },
      { value: 'IT', label: `${this.$t('countries.IT')}` },
      { value: 'LI', label: `${this.$t('countries.LI')}` },
      { value: 'LT', label: `${this.$t('countries.LT')}` },
      { value: 'LU', label: `${this.$t('countries.LU')}` },
      { value: 'LV', label: `${this.$t('countries.LV')}` },
      { value: 'MC', label: `${this.$t('countries.MC')}` },
      { value: 'MD', label: `${this.$t('countries.MD')}` },
      { value: 'MT', label: `${this.$t('countries.MT')}` },
      { value: 'NL', label: `${this.$t('countries.NL')}` },
      { value: 'NO', label: `${this.$t('countries.NO')}` },
      { value: 'PL', label: `${this.$t('countries.PL')}` },
      { value: 'PT', label: `${this.$t('countries.PT')}` },
      { value: 'RO', label: `${this.$t('countries.RO')}` },
      { value: 'RS', label: `${this.$t('countries.RS')}` },
      { value: 'RU', label: `${this.$t('countries.RU')}` },
      { value: 'SE', label: `${this.$t('countries.SE')}` },
      { value: 'SK', label: `${this.$t('countries.SK')}` },
      { value: 'SM', label: `${this.$t('countries.SM')}` },
      { value: 'UA', label: `${this.$t('countries.UA')}` },
    ],
    'label',
  );

  public get buttonEnabled() {
    return (
      this.models.title &&
      this.models.addressStreet &&
      this.models.addressStreetNumber &&
      this.models.addressZipCode &&
      this.models.addressCity &&
      this.models.addressCountry
    );
  }

  public created() {
    this.models = {
      title: userState.organization.title,
      addressStreet: userState.organization.addressStreet,
      addressStreetNumber: userState.organization.addressStreetNumber,
      addressZipCode: userState.organization.addressZipCode,
      addressCity: userState.organization.addressCity,
      addressCountry: userState.organization.addressCountry,
    };
  }

  public open() {
    this.modal.open();
  }

  public close() {
    this.modal.close();
  }

  public async updateOrganization() {
    try {
      const organization = await this.$api.updateOrganization({
        _id: userState.organization._id,
        organization: {
          title: this.models.title,
          addressStreet: this.models.addressStreet,
          addressStreetNumber: this.models.addressStreetNumber,
          addressZipCode: this.models.addressZipCode,
          addressCity: this.models.addressCity,
          addressCountry: this.models.addressCountry,
        },
      });

      userState.SET_ORGANIZATION(organization);

      this.close();
    } catch (error) {
      console.log(error);
    }
  }
}
